<template>

        <div v-if="slot.resource.capacity > 1">

            <div v-if="readonly">
                Rezervovaná kapacita
                <span class="form__input !w-16 mx-2" v-text="slot.capacity"></span>
                <span v-text="slot.resource.unit || 'jednotek zdroje'"></span>
            </div>

            <div v-else>
                Rezervovat
                <input class="!w-16 mx-2 text-right"
                    v-if="! readonly"
                    type="number"
                    v-model="slot.capacity"
                    :max="slot.resource.capacity"
                    @input="slot.capacity && emitChanged()"
                    @blur="emitChanged()"
                    />
                z celkem {{ slot.resource.capacity }}
                <span v-text="slot.resource.unit || 'jednotek zdroje'"></span>
            </div>

        </div>

</template>

<script>
export default {
    props: {
        readonly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            slot: this.$store.slot,
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input');
        }
    }
}
</script>
